<script setup lang="ts">
import type { SpecialSliderProps } from '@/types/appTypes'

const props = withDefaults(defineProps<SpecialSliderProps>(), {})
</script>

<template>
  <div class="l-container">
    <h2 class="l-container_title">
      特集
    </h2>

    <div class="l-container_ui">
      <div class="l-container_ui_carousel">
        <v-carousel
          class="IMCustomCarousel2"
          hide-delimiter-background
          cycle
          height="406"
        >
          <v-carousel-item
            v-for="(item, index) in items"
            v-bind:key="index"
          >
            <img
              class="l-container_ui_carousel_img"
              v-bind:src="item.image.url"
            >
            <div class="l-container_ui_carousel_blackBackGround" />
            <div class="l-container_ui_carousel_content">
              <div class="l-container_ui_carousel_content_title">
                <template
                  v-if="item.link"
                >
                  <nuxt-link
                    v-bind:to="item.link"
                  >
                    {{ item.title }}
                  </nuxt-link>
                </template>
                <template
                  v-else
                >
                  {{ item.title }}
                </template>
              </div>
              <div class="l-container_ui_carousel_content_detail">
                {{ item.body }}
              </div>
            </div>
          </v-carousel-item>
        </v-carousel>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.l-container {
  width: 100%;

  &_title {
    color: var(--color_text_base);
    font-family: "Noto Sans JP", sans-serif;
    font-size: 20px;
    font-weight: 400;
  }

  &_ui {
    display: flex;
    flex-direction: column;

    &_header {
      display: flex;
      margin-top: 10px;

      &_label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100px;
        min-width: 100px;
        max-width: 100px;
        height: 100px;
        padding: 29px 16px;
        background-color: #f2423e;
        color: var(--g_color_text_white);
        font-family: var(--g_font_family_NotoSansCJKjp);
        font-size: 26px;
        font-weight: bold;
        text-align: center;

        @include responsive.mq_down(sp) {
          width: 80px;
          min-width: 80px;
          max-width: 80px;
          height: 80px;
          padding: 20px 10px;
          font-size: 20px;
        }
      }

      &_content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 2px 0 4px 20px;

        @include responsive.mq_down(sp) {
          flex: 1;
          margin: 2px 0 4px 10px;
        }

        &_title {
          margin-bottom: 8px;
          color: var(--color_text_base);
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 26px;
          font-weight: bold;
          line-height: 1.2;

          @include responsive.mq_down(sp) {
            margin: 0 0 10px;
            font-size: 20px;
            line-height: 1.4;
          }
        }
      }
    }

    &_carousel {
      position: relative;
      margin-top: 28px;

      @include responsive.mq_down(sp) {
        margin-top: 20px;
      }

      &_img {
        width: 100%;
        object-fit: contain;

        @include responsive.mq_down(sp) {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          object-fit: cover;
        }
      }

      &_content {
        display: flex;
        position: absolute;
        top: 0;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        padding: 0 80px;

        @include responsive.mq_down(sp) {
          position: relative;
          top: 0;
          left: 0;
          height: 100%;
          padding: 30px 20px 20px;
        }

        &_title {
          color: white;
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 55px;
          font-weight: bold;
          line-height: 1.2;

          @include responsive.mq_down(sp) {
            font-size: 20px;
          }

          a {
            color: white;
            font-family: var(--g_font_family_NotoSansCJKjp);
            font-size: 55px;
            font-weight: bold;

            @include responsive.mq_down(sp) {
              font-size: 20px;
            }
          }
        }

        &_detail {
          width: 740px;
          margin-top: 20px;
          color: white;
          font-family: var(--g_font_family_NotoSansCJKjp);
          font-size: 18px;
          font-weight: bold;
          line-height: 1.7;

          @include responsive.mq_down(sp) {
            width: 100%;
            font-size: 16px;
          }
        }
      }

      &_blackBackGround {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0.5;
        background-color: var(--g_color_background_black);
      }
    }
  }
}
</style>
